// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"spinnerContainer___HbkpF","googleLinksContainer":"googleLinksContainer___D9Hbt"};